import React from 'react'
import { GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK } from 'requests'
import { connect } from 'react-redux'
import { storeAndDispatchLoginResponse } from '../../Auth/AuthActions'
import { Body } from '../Shell/Shell'
import { parseUrlQuery } from 'utilities'
import { Spinner } from '../Loaders/Loaders'
import { PaymentError } from '../Checkout/PaymentCallback'
import ls from 'local-storage'

const ActiveDirectoryCallback = ({ dispatch, history }) => {
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    const code = parseUrlQuery(location.search).code
    const error = parseUrlQuery(location.search).error
    const error_description = parseUrlQuery(location.search).error_description
    GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK({ code: code, error: error, error_description: error_description },
      user => {
        storeAndDispatchLoginResponse(user, dispatch)
        const returnUrl = ls.get('ACTIVE_DIRECTORY_RETURN_URL') || '/'
        history.replace(returnUrl)
      },
      err => {
        console.error(err)
        setError(err)
      }
    )
  }, [])
  return (
    <Body className="login-redirector">
      {error ? (
        <div className="payment-callback">
          <PaymentError errorCode={error.code} children={error.message} />
        </div>
      ) : (
        <Spinner className="page-loader" />
      )}
    </Body>
  )
}
export default connect()(ActiveDirectoryCallback)



// WEBPACK FOOTER //
// ./src/components/ActiveDirectory/ActiveDirectoryCallback.js